import Button from '@components/V4/Button';
import Modal from '@components/V4/Modal/Modal';

type LeaveMeetingModalProps = {
  isOpen: boolean;
  isMentor: boolean;
  onClose: () => void;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
};

const LeaveMeetingModal = (props: LeaveMeetingModalProps) => {
  const { isOpen, isMentor, onClose, onPrimaryButtonClick, onSecondaryButtonClick } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small">
      <Modal.Header title="Leave Meeting" className="text-center" />
      <Modal.Body className="flex flex-col justify-center items-center overflow-x-hidden mb-6 text-center text-xs leading-5">
        <div className="flex flex-col gap-4">
          <p>You are about to leave without ending the meeting.</p>
          {isMentor ? (
            <p>
              The video call will close for everyone, but the meeting won&apos;t be marked as ended
              or completed. You and the student can rejoin from the meeting page at any time.
            </p>
          ) : (
            <p>
              The meeting won&apos;t be marked as ended or completed — you can rejoin from the
              meeting page at any time.
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-center gap-4">
        <Button
          className="h-6 min-h-6"
          size="large"
          variant="secondary"
          buttonText="Stay in meeting"
          onClick={onSecondaryButtonClick}
        />
        <Button
          className="h-6 min-h-6"
          size="large"
          variant="primary"
          buttonText="Leave"
          onClick={onPrimaryButtonClick}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default LeaveMeetingModal;
